import React from "react";
import DefaultCard from "./default-card";
import {loginUrl} from '../constants';
import ucaEnv from "../../../../common/env/env-uca";
import { useApi } from "../../../../hooks";
import { CommonModule } from "uca-react-containers-library";

const EmailCard = ({ banner, category, isGuest }) => {
    const { appData: { env, platform } } = CommonModule.useApp();
    const environmentVariables = ucaEnv(banner, env, platform);
    const { data } = useApi(`${environmentVariables.REWARDS_PAGE_BASE_API}/customer/account-details`) || {};
    const email = data ? data.userInfo.email : null;
    const desc = email ? (email.split('@')[0].length > 20 ? email.split('@')[0].substring(0,20) + '...' : email.split('@')[0]) + '@' +  email.split('@').pop() : null;

    return (
        <DefaultCard
          category={{
            ...category,
            desc,
            link: {
              ...category.link,
              href: isGuest
                ? loginUrl
                : category.link.href,
              defaultUrl:`/help/accounts`,
            },
          }}
          shrinkable={true}
        />
      )
};

export default EmailCard;
